const otherResources = {
  en: {
    p1: {
      'Полис ДГПО авто действует при наличии ОГПО ВТС':
        'The DGPO auto policy is valid only if there is an MTPL policy',
      'Страховая сумма': 'Insured amount',
      'Срок страхования': 'Insurance period',
      '12 месяцев': '12 months',
      'Страховая сумма должна быть от': 'The insured amount must be at least',
      месяц: 'month',
      месяца: 'months',
      месяцев: 'months',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'The verification code has already been sent, please wait before resending',
      'Код подтверждения успешно отправлен на телефон':
        'The verification code has been successfully sent to your phone',
      'Включить страховку от Несчастного случая за 2000 ₸ на год':
        'Add accident insurance for 2000 ₸ per year',
      'Включить страховку от Несчастного случая за 1500 ₸ на год':
        'Add accident insurance for 1500 ₸ per year',
      Личная: 'Personal',
      Иное: 'Other',
      Страхователь: 'Insurant',
      Застрахованный: 'Insured person',
      '2% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        '2% of the insured vehicle amount, but not less than 15,000 ₸ for partial damage, 7% for total loss or theft',

      '1% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        '1% of the insured vehicle amount, but not less than 15,000 ₸ for partial damage, 7% for total loss or theft',

      '2% от страховой суммы ТС, но не менее 15 000 тенге':
        '2% of the insured vehicle amount, but not less than 15,000 ₸',

      '0% при частичном повреждении и 7% при полной гибели и по риску кража/угон':
        '0% for partial damage, 7% for total loss or theft',

      Легковой: 'Passenger car',
      Микроавтобусы: 'Minibuses',
      Автобусы: 'Buses',
      'Лимит на один случай': 'Limit per incident',
      'Количество пассажирских мест:': 'Number of passenger seats:',
      'Тип ТС': 'Vehicle type',
      'до 4 пассажирских мест включительно':
        'up to 4 passenger seats inclusive',
      'свыше 4 до 7 пассажирских мест включительно':
        'more than 4 up to 7 passenger seats inclusive',
      'свыше 7 до 16 пассажирских мест включительно':
        'more than 7 up to 16 passenger seats inclusive',
      'свыше 16 до 30 пассажирских мест включительно':
        'more than 16 up to 30 passenger seats inclusive',
      'свыше 30 до 50 пассажирских мест включительно':
        'more than 30 up to 50 passenger seats inclusive',
      'Пожалуйста, введите ваше имя': 'Please enter your first name',
      'Пожалуйста, введите вашу фамилию': 'Please enter your last name',
      'Подтвердите согласие на обработку данных':
        'Please confirm consent to data processing',
      'Ваш запрос успешно отправлен!':
        'Your request has been successfully submitted!',
      'Исправьте ошибки выше': 'Please correct the errors above',
      'Закажите обратный звонок': 'Request a callback',
      'Закажите обратный звонок, и наш специалист свяжется с вами в ближайшее время.':
        'Request a callback, and our specialist will contact you shortly.',
      Имя: 'First name',
      'Введите ваше имя': 'Enter your first name',
      Фамилия: 'Last name',
      'Введите вашу фамилию': 'Enter your last name',
      contact_us_consent_text:
        'I confirm my consent to <1>the collection and processing of personal data</1> and acknowledge the <2>privacy policy</2>.',
    },
  },
  kz: {
    p1: {
      'Полис ДГПО авто действует при наличии ОГПО ВТС':
        'Автокөлікке арналған АҚЖЕС полисі тек КҚИАҚЖАМС полисі болған жағдайда ғана жарамды',
      'Страховая сумма': 'Сақтандыру сомасы',
      'Срок страхования': 'Сақтандыру мерзімі',
      '12 месяцев': '12 ай',
      'Страховая сумма должна быть от': 'Сақтандыру сомасы кемінде болуы тиіс',
      месяц: 'ай',
      месяца: 'ай',
      месяцев: 'ай',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'Растау коды жіберілді, қайта жіберу үшін біраз күтіңіз',
      'Код подтверждения успешно отправлен на телефон':
        'Растау коды телефонға сәтті жіберілді',
      'Включить страховку от Несчастного случая за 2000 ₸ на год':
        'Жылына 2000 ₸ тұратын жазатайым оқиғалардан сақтандыруды қосу',
      'Включить страховку от Несчастного случая за 1500 ₸ на год':
        'Жылына 1500 ₸ тұратын жазатайым оқиғалардан сақтандыруды қосу',
      Личная: 'Жеке',
      Иное: 'Өзге',
      Страхователь: 'Сақтанушы',
      Застрахованный: 'Сақтандырылған тұлға',
      '2% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        'Көлік құралының сақтандыру сомасының 2%-ы, бірақ ішінара зақымданған жағдайда кемінде 15 000 теңге, толық жойылу немесе ұрлық/айдап әкету қаупі бойынша – 7%',

      '1% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        'Көлік құралының сақтандыру сомасының 1%-ы, бірақ ішінара зақымданған жағдайда кемінде 15 000 теңге, толық жойылу немесе ұрлық/айдап әкету қаупі бойынша – 7%',

      '2% от страховой суммы ТС, но не менее 15 000 тенге':
        'Көлік құралының сақтандыру сомасының 2%-ы, бірақ кемінде 15 000 теңге',

      '0% при частичном повреждении и 7% при полной гибели и по риску кража/угон':
        'Ішінара зақымданған жағдайда – 0%, толық жойылу немесе ұрлық/айдап әкету қаупі бойынша – 7%',
      Легковой: 'Жеңіл көлік',
      Микроавтобусы: 'Микроавтобустар',
      Автобусы: 'Автобустар',
      'Лимит на один случай': 'Бір оқиғаға арналған лимит',
      'Количество пассажирских мест:': 'Жолаушылар орнының саны:',
      'Тип ТС': 'Көлік түрі',
      'до 4 пассажирских мест включительно':
        '4 жолаушы орнына дейін қоса алғанда',
      'свыше 4 до 7 пассажирских мест включительно':
        '4-тен 7 жолаушы орнына дейін қоса алғанда',
      'свыше 7 до 16 пассажирских мест включительно':
        '7-ден 16 жолаушы орнына дейін қоса алғанда',
      'свыше 16 до 30 пассажирских мест включительно':
        '16-дан 30 жолаушы орнына дейін қоса алғанда',
      'свыше 30 до 50 пассажирских мест включительно':
        '30-дан 50 жолаушы орнына дейін қоса алғанда',
      'Пожалуйста, введите ваше имя': 'Атыңызды енгізіңіз',
      'Пожалуйста, введите вашу фамилию': 'Тегіңізді енгізіңіз',
      'Подтвердите согласие на обработку данных':
        'Деректерді өңдеуге келісімді растаңыз',
      'Ваш запрос успешно отправлен!': 'Сұраныс сәтті жіберілді!',
      'Исправьте ошибки выше': 'Жоғарыдағы қателерді түзетіңіз',
      'Закажите обратный звонок': 'Қайта қоңырау шалуға тапсырыс беру',
      'Закажите обратный звонок, и наш специалист свяжется с вами в ближайшее время.':
        'Қайта қоңырауға тапсырыс беріңіз, және біздің маман жақын арада хабарласады.',
      Имя: 'Аты',
      'Введите ваше имя': 'Атыңызды енгізіңіз',
      Фамилия: 'Тегі',
      'Введите вашу фамилию': 'Тегіңізді енгізіңіз',
      contact_us_consent_text:
        'Мен <1>жеке деректерді жинауға және өңдеуге</1> келісімімді растаймын және <2>құпиялық саясатымен</2> таныстым.',
    },
  },
  ru: {
    p1: {
      'Полис ДГПО авто действует при наличии ОГПО ВТС':
        'Полис ДГПО авто действует при наличии ОГПО ВТС',
      'Страховая сумма': 'Страховая сумма',
      'Срок страхования': 'Срок страхования',
      '12 месяцев': '12 месяцев',
      'Страховая сумма должна быть от': 'Страховая сумма должна быть от',
      месяц: 'месяц',
      месяца: 'месяца',
      месяцев: 'месяцев',
      'Код подтверждения уже отправлен, время повторной отправки ещё не наступило':
        'Код подтверждения уже отправлен, время повторной отправки ещё не наступило',
      'Код подтверждения успешно отправлен на телефон':
        'Код подтверждения успешно отправлен на телефон',
      'Включить страховку от Несчастного случая за 2000 ₸ на год':
        'Включить страховку от Несчастного случая за 2000 ₸ на год',
      'Включить страховку от Несчастного случая за 1500 ₸ на год':
        'Включить страховку от Несчастного случая за 1500 ₸ на год',
      Личная: 'Личная',
      Иное: 'Иное',
      Страхователь: 'Страхователь',
      Застрахованный: 'Застрахованный',
      '2% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        '2% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон',

      '1% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон':
        '1% от страховой суммы ТС, но не менее 15 000 тенге при частичном повреждении, 7% при полной гибели и по риску кража/угон',

      '2% от страховой суммы ТС, но не менее 15 000 тенге':
        '2% от страховой суммы ТС, но не менее 15 000 тенге',

      '0% при частичном повреждении и 7% при полной гибели и по риску кража/угон':
        '0% при частичном повреждении и 7% при полной гибели и по риску кража/угон',
      Легковой: 'Легковой',
      Микроавтобусы: 'Микроавтобусы',
      Автобусы: 'Автобусы',
      'Лимит на один случай': 'Лимит на один случай',
      'Количество пассажирских мест:': 'Количество пассажирских мест:',
      'Тип ТС': 'Тип ТС',
      'до 4 пассажирских мест включительно':
        'до 4 пассажирских мест включительно',
      'свыше 4 до 7 пассажирских мест включительно':
        'свыше 4 до 7 пассажирских мест включительно',
      'свыше 7 до 16 пассажирских мест включительно':
        'свыше 7 до 16 пассажирских мест включительно',
      'свыше 16 до 30 пассажирских мест включительно':
        'свыше 16 до 30 пассажирских мест включительно',
      'свыше 30 до 50 пассажирских мест включительно':
        'свыше 30 до 50 пассажирских мест включительно',
      'Пожалуйста, введите ваше имя': 'Пожалуйста, введите ваше имя',
      'Пожалуйста, введите вашу фамилию': 'Пожалуйста, введите вашу фамилию',
      'Подтвердите согласие на обработку данных':
        'Подтвердите согласие на обработку данных',
      'Ваш запрос успешно отправлен!': 'Ваш запрос успешно отправлен!',
      'Исправьте ошибки выше': 'Исправьте ошибки выше',
      'Закажите обратный звонок': 'Закажите обратный звонок',
      'Закажите обратный звонок, и наш специалист свяжется с вами в ближайшее время.':
        'Закажите обратный звонок, и наш специалист свяжется с вами в ближайшее время.',
      Имя: 'Имя',
      'Введите ваше имя': 'Введите ваше имя',
      Фамилия: 'Фамилия',
      'Введите вашу фамилию': 'Введите вашу фамилию',
      contact_us_consent_text:
        'Я подтверждаю согласие на <1>сбор и обработку персональных данных</1> и ознакомлен(а) с <2>политикой конфиденциальности</2>.',
    },
  },
};

export default otherResources;
